import axios from "axios";
import services from "@/config/services";

export default class FlussiOreService {

    constructor (eventBus) {
        this.eventBus = eventBus;
        this.baseUrlFlussi = `${services.ask_flussi_api.url}`;
    }

    async getFlussiOre(page = 1, perPage = 10, sortField = null, sortOrder = null) {
        const url = `${this.baseUrlFlussi}/letture_ore/mostra`;
        const params = { page, per_page: perPage };

        if (sortField) params.sort_field = sortField;
        if (sortOrder) params.sort_order = sortOrder === 1 ? 'asc' : 'desc';

        try {
            const res = await axios.get(url, { params });
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }

    async searchPod(pod, dataMisura = '', page = 1, perPage = 10, sortField = null, sortOrder = null) {
        const url = `${this.baseUrlFlussi}/letture_ore/cerca/pod`;
        const params = { pod, page, per_page: perPage };

        if (sortField) params.sort_field = sortField;
        if (sortOrder) params.sort_order = sortOrder === 1 ? 'asc' : 'desc';
        if (dataMisura != '') params.data_misura = dataMisura;

        try {
            const res = await axios.get(url, { params });
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }

    async getLettureConsumo(pod, dataMisura) {
        const url = `${this.baseUrlFlussi}/letture_ore/cerca/pod/letture`;
        const params = { pod, data_misura: dataMisura };

        try {
            const res = await axios.get(url, { params });
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }

    async getSommaFasce(pod, dataMisura) {
        const url = `${this.baseUrlFlussi}/letture_ore/somma/fasce`;
        const params = { pod, data_misura: dataMisura };

        try {
            const res = await axios.get(url, { params });
            return res.data;
        } catch(err) {
            this.eventBus.emit("data-load-error", { message: err, url });
            return null;
        }
    }

}